import React, { lazy, Suspense } from 'react';

const Work = lazy(() => import('./work'));

const WorkWithSuspense = () => (
  <Suspense fallback={null}>
    <Work />
  </Suspense>
);

export default WorkWithSuspense;